import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EFFImage from '@elem/ui/eff-image';

const Banner: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Banner');
    return (
        <div className={styles.Banner + ' GtmModuleData-section'} data-section-id="banner">
            <div className="banner-image">
                <img
                    fetchpriority="high"
                    src="https://websiteoss.ecoflow.com/figma-uploads/1764744910771-ofmyv2-compressed-Rectangle%206364.webp"
                    alt="banner"
                />
            </div>
            {/* <EFFImage
                alt="banner"
                priority={true}
                sources={{
                    default: {
                        webp: 'https://websiteoss.ecoflow.com/figma-uploads/1764744910771-ofmyv2-compressed-Rectangle%206364.webp',
                        fallback: '',
                    },
                }}
            /> */}
            <div className="content">
                <div className="title">{t('title')}</div>
            </div>
        </div>
    );
};

export default Banner;
